import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';

import useLocal from 'localization';
// import { RootState } from 'store';

// import { UsersSelectors } from './duck';
import { UsersTypes } from './duck';
// import { actionTypes } from './duck';
// import useStyles from './style';

const Users: React.FC<UsersTypes.UsersProps> = () => {
  // const classes = useStyles();
  // const dispatch = useDispatch();

  // const localizedText = useLocal('translation_key');

  // useEffect(() => {
  //   dispatch({
  //     type: actionTypes.TEST1_ACTION
  //   });

  //   return () => {
  //     dispatch({
  //       type: actionTypes.TEST2_ACTION
  //     });
  //   };
  // }, [dispatch]);

  return (
    <div>
      <h1>{useLocal('user_info')}</h1>
    </div>
  );
};

export default Users;
